export default __webpack_public_path__ + "static/media/alimentacion_enteral_pediatria.bfcbda16.pdf";